import { render, staticRenderFns } from "./loadmore.vue?vue&type=template&id=702744f4&scoped=true"
import script from "./loadmore.vue?vue&type=script&lang=js"
export * from "./loadmore.vue?vue&type=script&lang=js"
import style0 from "./loadmore.vue?vue&type=style&index=0&id=702744f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702744f4",
  null
  
)

export default component.exports